if (!customElements.get('ev-catalog-products')) {
  customElements.define('ev-catalog-products', class extends HTMLElement {
    static get observedAttributes() { return ['src']; }
    connectedCallback() { if (this.getAttribute('src')) this.load(this.getAttribute('src')); }
    attributeChangedCallback(name, oldValue, value) { if (this.isConnected && value && value !== oldValue) this.load(value); }
    async load(source, append = false) {
      this.controller?.abort();
      this.controller = new AbortController();
      const controller = this.controller;
      this.setAttribute('aria-busy', 'true');
      let status = this.querySelector('[data-ev-catalog-status]');
      if (!append) {
        this.replaceChildren();
        status = document.createElement('p');
        status.dataset.evCatalogStatus = '';
        status.setAttribute('role', 'status');
        status.textContent = this.dataset.loading;
        this.append(status);
      }
      const more = this.querySelector('[data-ev-more]');
      if (more) more.disabled = true;
      try {
        const url = new URL(source, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid catalog URL');
        url.searchParams.set('view', 'ev-product-cards');
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('Catalog unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = doc.querySelector('[data-ev-catalog-page]');
        if (!page) throw new Error('Catalog response missing');
        let grid = this.querySelector('.ev-remote-grid');
        if (!grid) {grid = document.createElement('div');grid.className = 'ev-remote-grid';this.append(grid);}
        grid.append(...page.querySelector('[data-ev-catalog-cards]').children);
        this.querySelector('[data-ev-more]')?.remove();
        const total = Number(page.dataset.total);
        status.textContent = total ? this.dataset.count.replace('[count]', total) : this.dataset.empty;
        const next = page.querySelector('[data-ev-catalog-next]');
        if (next) {
          const button = document.createElement('button');
          button.type = 'button';button.className = 'ev-catalog-more';button.dataset.evMore = '';
          button.textContent = this.dataset.more;
          button.addEventListener('click', () => this.load(next.getAttribute('href'), true));
          this.append(button);
        }
        this.dispatchEvent(new CustomEvent('ev:cards:loaded', {bubbles:true}));
      } catch (error) {
        if (error.name === 'AbortError') return;
        status.textContent = this.dataset.error;
        if (more) more.disabled = false;
      } finally {
        if (this.controller === controller) this.removeAttribute('aria-busy');
      }
    }
  });
}
